import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postPaymentsCheckoutSessions,
  type PostPaymentsCheckoutSessionsParams,
  type PostPaymentsCheckoutSessionsResponse,
} from '@services/PaymentsService';

export type UsePostPaymentsCheckoutSessionsParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostPaymentsCheckoutSessionsResponse,
    unknown,
    string,
    PostPaymentsCheckoutSessionsParams,
    PostPaymentsCheckoutSessionsResponse
  >;
};

export const postPaymentsCheckoutSessionsMutationKey =
  'post-payments-checkout-sessions';

export const usePostPaymentsCheckoutSessions = ({
  mutationOptions,
}: UsePostPaymentsCheckoutSessionsParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostPaymentsCheckoutSessionsResponse,
    unknown,
    string,
    PostPaymentsCheckoutSessionsParams
  >(
    postPaymentsCheckoutSessionsMutationKey,
    (_url, { arg }) => postPaymentsCheckoutSessions(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
